import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-next-button",
  template: `
    <button
      [routerLink]="[buttonInfo.routeUrl]"
      [disabled]="buttonInfo.isDisable"
      type="button"
      class="btn-next btn-block"
      [ngClass]="buttonInfo.cssClass"
      (click)="onButtonClick($event)"
      styles="box-shadow: 0px 4px 4px rgba(23, 88, 106, 0.28);"
    >
      {{ "label." + buttonInfo.buttonText | translate }}
    </button>
  `,
  styles: [".btn-next:focus{outline: none}"],
})
export class NextButtonComponent {
  @Input() buttonInfo: NavButton = {
    buttonText: "Text Button",
    routeUrl: "/m/main",
    cssClass: "my-class",
    isDisable: false,
  };
  @Output() btnClickedEvent = new EventEmitter<any>();

  onButtonClick(event: any){
    this.btnClickedEvent.emit(event);
  }
}

export interface NavButton {
  routeUrl?: string;
  buttonText: string;
  cssClass?: string;
  isDisable?: boolean;
  number?: number;
}
// [disabled]="buttonInfo.isDisable"
